import ru from 'element-plus/es/locale/lang/ru';

export const customRu = {
  ...ru,
  el: {
    ...ru.el,
    datepicker: {
      ...ru.el.datepicker,
      now: 'Сейчас',
      today: 'Сегодня',
      cancel: 'Отмена',
      confirm: 'ОК',
      selectDate: 'Выберите дату',
      selectTime: 'Выберите время',
      startDate: 'Дата начала',
      startTime: 'Время начала',
      endDate: 'Дата окончания',
      endTime: 'Время окончания',
    }
  }
};